module.exports = {"dashboard":"Gösterge Paneli","search":"Ara","calendar":"Takvim","mailbox":"Mail","widgets":"Araçlar","social":"Sosyal","charts":"Grafikler","media":"Medya","overlays":"Ekran Ayarları","snackbar":"Gösterge","authorization":"Yetki","login":"Giriş","users":"Kullanıcılar","widgetTodaysVisit":"Bugün ki Ziyaret","widgetTodaysSale":"Bugünki Satış","widgetUniqueVisits":"% Ziyaretci","widgetBounceRate":"Sıçrama Oranı","widgetHigherYesterday":"dün {0} daha yüksek","widgetBeforeTax":"{0} vergi öncesi","widgetAverageDuration":"{0} ortalama süre","widgetAverageTime":"{0} ortalama süre"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/tr.json
// module id = 8EGb
// module chunks = 1